export enum GTMEvent {
  PUSH_PARAMS = 'GTM event to GA',
  ENTER_EMAIL = 'enter_email',
}

export enum GTMEventLabel {
  START = 'start',
  CONFIRM_SCREEN = 'confirm screen',
  SUBMIT_APPLICATION = 'submit application',

  // OLD PARAMS, KEEP FOR NOW
  // ADD_OWNER = 'add-owner',
  // ONBOARDING_DONE = 'onboarding done',
  // FAILED_KYC = 'Permanet KYC fail',
  // KYB_LOADER = 'KYB loader',
  // HANG_TIGHT = 'Hang Tight',
  // VERIFICATION_CENTER = 'Verification Center',
  // NAME_TOO_LONG = 'name too long',
  // PLAN_SELECTION = 'plan selection',
  // FAILED_KYC_CHECKING = 'KYC uncertain hang tight',
  // FAILED_KYC_MORE_INFO = 'Failed KYC pass to socure',
  // ADDRESS_DETAILS = 'address details',
  // BUSINESS_TYPE_SELECTION = 'business-type-selection',
  // BUSINESS_DBA_TYPE_SELECTION = 'business-dba-type-selection',
  // BUSINESS_SUB_TYPE_SELECTION = 'business-sub-type-selection',
  // PHONE_NUMBER = 'phone number',
  // SSN_DETAILS = 'ssn details',
  // CONTACT_DETAILS = 'contact details',
  // OWNER_CENTER = 'owner-center',
  // PICKUP_WHERE_YOU_LEFT = 'Pickup where you left',
}
